import React, { FC, useContext, useMemo, useState } from "react";
import Accordion from "../accordion/accordion";
import { ObjectFieldTemplatePropertyType, ObjectFieldTemplateProps } from "@rjsf/utils";
import { SearchContext } from "../../constants/contexts";
import styles from "../../pages/tenants/tenants.module.css";
import cn from "classnames";

export const AccordionField: FC<ObjectFieldTemplateProps> = ({ title, properties }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { term } = useContext(SearchContext);

  const hasProperties = useMemo(() => {
    if (!term) return true;
    return Array.isArray(properties)
      ? properties.some((element) => element.name.toLowerCase().startsWith(term.toLowerCase()))
      : true;
  }, [term]);

  if (!hasProperties) return <div className={styles.hiddenField}></div>;

  return (
    <Accordion header={title} isCollapsed={isCollapsed} onToggleCollapse={() => setIsCollapsed((prev) => !prev)}>
      <div className={styles.container}>
        {Array.isArray(properties)
          ? properties.map((element: ObjectFieldTemplatePropertyType, index: number) => {
              return (
                <div
                  key={index}
                  className={cn({
                    [styles.hiddenField]: term && !element.name.toLowerCase().startsWith(term.toLowerCase()),
                  })}
                >
                  {element.content}
                </div>
              );
            })
          : properties}
      </div>
    </Accordion>
  );
};
